import React from "react";

function Discount() {
  return (
    <div className="discount">
      <span>Repair services</span>
      <h2>
        {" "}
        Up to <span className="discount-percent">70% Off</span>- All t-Shirts &
        Accessories
      </h2>
      <a href="#d">Explore More</a>
    </div>
  );
}

export default Discount;
